module.exports = "/_next/static/images/offline_product_howto-7c13e18154ecf2e5019d16133c7e26a5.svg";